import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GeneralEmitterService {
  chartData: EventEmitter<boolean> = new EventEmitter<boolean>();
  btnStartQuotation: EventEmitter<boolean> = new EventEmitter<boolean>();
  showSpinner: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {
    
  }
}
